"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const jsx_runtime_1 = require("react/jsx-runtime");
// @ts-ignore-next-line importsNotUsedAsValues
require("react");
const classnames_1 = tslib_1.__importDefault(require("classnames"));
const SidebarFooter = ({ footer, className = '' }) => {
    if (!footer) {
        return null;
    }
    const footerClassNames = (0, classnames_1.default)('SidebarFooter', className);
    return (0, jsx_runtime_1.jsx)("div", Object.assign({ className: footerClassNames }, { children: footer }));
};
exports.default = SidebarFooter;
